import { useState } from 'react';

const shareTargets = [
  { key: 'wechat', label: '微信', icon: 'ri-wechat-fill', color: 'text-primary-600' },
  { key: 'weibo', label: '微博', icon: 'ri-weibo-fill', color: 'text-accent-600' },
  { key: 'qq', label: 'QQ', icon: 'ri-qq-fill', color: 'text-secondary-700' },
  { key: 'bili', label: '哔哩哔哩', icon: 'ri-bilibili-fill', color: 'text-primary-500' },
];

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState('');

  const handleShare = (label: string) => {
    setToast(`已触发「${label}」分享（前端演示，未接入真实接口）`);
    window.setTimeout(() => setToast(''), 2200);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setToast('链接已复制到剪贴板');
    } catch {
      setToast('已生成分享链接（演示）');
    }
    window.setTimeout(() => setToast(''), 2200);
  };

  return (
    <div className="relative rounded-lg border border-background-200 bg-background-100 p-4">
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex items-center gap-1.5 text-sm font-medium text-foreground-700">
          <i className="ri-share-forward-line"></i>
          分享这条资讯
        </span>
        <div className="flex flex-wrap items-center gap-2">
          {shareTargets.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => handleShare(t.label)}
              title={`分享到${t.label}`}
              className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 transition-colors hover:bg-primary-50 cursor-pointer"
            >
              <i className={`${t.icon} ${t.color} text-xl`}></i>
            </button>
          ))}
          <button
            type="button"
            onClick={copyLink}
            title="复制链接"
            className="flex h-10 items-center gap-1.5 rounded-md bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:bg-primary-50 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-link"></i>
            复制链接
          </button>
        </div>
      </div>
      <p className="mt-3 text-xs text-foreground-400">当前资讯：{title}</p>
      {toast && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 -translate-y-full rounded-md bg-foreground-950 px-4 py-2 text-xs text-background-50 animate-fade-rise">
          {toast}
        </div>
      )}
    </div>
  );
}